import { useTranslation } from 'react-i18next'

import Button from '../../../Button'
import { PageEmptyState } from '../../../PageEmptyState'
import {
  APPLICANTS_CLEAR_FILTERS_ACTION_NAME,
  QA_NAME_APPLICANTS_CLEAR_FILTERS,
} from '../RentalPortalApplicants.constants'

import UsersIcon from '../../../../icons/users-1.svg'

function RentalPortalApplicantsEmptyState({
  hasActiveFilters,
  onClearFilters,
}) {
  const { t } = useTranslation()

  return hasActiveFilters ? (
    <PageEmptyState
      EntityIcon={UsersIcon}
      actions={[
        {
          Component: Button.Flat,
          name: APPLICANTS_CLEAR_FILTERS_ACTION_NAME,
          qaName: QA_NAME_APPLICANTS_CLEAR_FILTERS,
          text: t('Table.ClearFilterBtnKey'),
          onClick: onClearFilters,
        },
      ]}
      text={t('RentalPortal.ApplicantsNoFilterResultsKey')}
    />
  ) : (
    <PageEmptyState
      EntityIcon={UsersIcon}
      text={t('RentalPortal.ApplicantsNoDataKey')}
    />
  )
}

export default RentalPortalApplicantsEmptyState
